import * as React from 'react';
import * as styles from './Notification.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TooltipContent(_ref) {
  var description = _ref.description,
    button = _ref.button;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['tooltip-container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['message'],
      children: description
    }), button]
  });
}